import React, { Component, useCallback } from "react";
import { Input, Button, Select } from "antd";
import { nation } from "./fieldOptions/dict";
import * as otherOptions from "./fieldOptions/otherOptions";
import Cascader from "@/components/Cascader";
const { TextArea } = Input;

function getNameLabel(name, value) {
  let label = value;
  otherOptions[name] &&
    otherOptions[name].forEach(
      (item) => item.value == value && (label = item.label)
    );
  return label;
}

export const RenderForm = ({
  dataList,
  children,
  onChange,
  onChange2,
  handleCancel,
  handleSave,
}) => {
  return (
    <div className="render_form">
      <ul className="base_info_list">
        {dataList.length &&
          dataList.map((item, itemIndex) => {
            return (
              <li
                className={[
                  "base_info_item",
                  item.name == "jobContent" ? "job_content" : "",
                  item.require ? "require" : "",
                ].join(" ")}
                key={itemIndex}
              >
                {children({ ...item, onChange, onChange2 })}
              </li>
            );
          })}
      </ul>
      {/* <div className='cancel_save'>
                <div className="cancel_btn" onClick={handleCancel}>取消</div>
                <div className="save_btn" onClick={handleSave}>保存</div>
            </div> */}
    </div>
  );
};

export const RenderFormItem = ({
  type,
  label,
  name,
  value,
  placeholder,
  options,
  rules = [],
  onChange,
  onChange2,
}) => {
  let rule = {};
  rules.length &&
    rules.forEach((ele) => {
      rule[ele.trigger] = ele;
    });
  let v = value;
  const handleChange = useCallback((e, name) => {
    if (typeof e == "string" || typeof e == "number" || Array.isArray(e)) {
      v = e; //如果e的值是字符串或者数组
    } else {
      e.persist(); //用于保留react合成事件中的属性值
      v = e.target.value;
    }
    // console.log("------handleChange------", v);
    onChange(v, name);
  }, []);
  const handleChange2 = useCallback(
    (e, name) => {
      // console.log("useCallback", e, name);

      let v = "";
      if (e.countyName) {
        v = `${e.provinceName},${e.cityName},${e.countyName}`;
      } else if (e.cityName) {
        v = `${e.provinceName},${e.cityName}`;
      } else if (e.provinceName) {
        v = `${e.provinceName}`;
      }
      onChange(v, name);
      onChange2(e);
    },
    [onChange, onChange2]
  );
  const handleBlur = useCallback(() => {
    if (rule.blur && rule.blur.required && !v) {
      console.log(rule.blur.message + label);
    }
  }, [label, rule.blur, v]);

  switch (type) {
    case "select":
      return (
        <>
          <span className="form_label">{label}</span>
          <Select
            name={`${name}`}
            value={value}
            options={options}
            placeholder={placeholder}
            onChange={(e) => {
              handleChange(e, `${name}`);
            }}
          >
            {options.map((el) => {
              return (
                <Select.Option key={el.label} value={el.value}>
                  {el.label}
                </Select.Option>
              );
            })}
          </Select>
        </>
      );
    case "area":
      if (value) {
        // console.log("111111111111");

        value = value.split(",");
      }
      // console.log("valuevaluevaluevalue", value);

      return (
        <>
          <span className="form_label">{label}</span>
          <Cascader
            allCitys
            meishan
            name={`${name}`}
            defaultValue={value}
            className="form_cascader_box"
            onChange={(e) => {
              handleChange2(e, `${name}`);
            }}
            bespread
          ></Cascader>
        </>
      );
    default:
      return (
        <>
          <span className="form_label">{label}</span>
          {name === "auditMechanismIntroduce" ? (
            <TextArea
              type="text"
              name={`${name}`}
              maxLength={500}
              rows={4}
              value={value}
              onChange={(e) => {
                handleChange(e, `${name}`);
              }}
              placeholder={placeholder}
            />
          ) : name === "auditMechanismType" ? (
            <Input disabled type="text" name={`${name}`} id="" value={value} />
          ) : (
            <Input
              type="text"
              rows={4}
              maxLength={50}
              name={`${name}`}
              value={value}
              onBlur={handleBlur}
              onChange={(e) => {
                handleChange(e, `${name}`);
              }}
              placeholder={placeholder}
            />
          )}
        </>
      );
  }
};

export const EchoForm = ({ dataList }) => {
  return (
    <div className="echo_form_content">
      <ul className="base_info_list">
        {dataList &&
          dataList.map(({ label, name, value }) => {
            return true ? (
              <li className="base_info_item" key={label}>
                <div className="form_echo">
                  <span className="form_label_echo">{label}:</span>
                  <span
                    className={[
                      "form_item_echo",
                      name == "auditMechanismIntroduce"
                        ? "width_fit_content"
                        : "",
                    ].join(" ")}
                  >
                    {getNameLabel(name, value)}
                  </span>
                </div>
              </li>
            ) : (
              ""
            );
          })}
      </ul>
    </div>
  );
};
